import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services';
import {
  GetBillToAccountsParams,
  GetBillToAccountsResponse,
  GetBrandBillingConfigParams,
  GetBrandBillingConfigResponse,
  SetBrandBillingConfigParams,
  SetBrandBillingConfigResponse,
} from '../billings.proto';

@Injectable({
  providedIn: 'root',
})
export class BillingsService {
  constructor(private readonly apiService: ApiService) {}

  getBrandBillingConfig(
    getBrandBillingConfigParams: GetBrandBillingConfigParams
  ): Observable<GetBrandBillingConfigResponse> {
    const params: HttpParams = this.apiService.queryParams(
      getBrandBillingConfigParams
    );
    return this.apiService.get(
      `/v2/brands/${getBrandBillingConfigParams.brandId}/billing-config`,
      params
    );
  }

  getBillToAccounts(
    getBillToAccountsParams: GetBillToAccountsParams
  ): Observable<GetBillToAccountsResponse> {
    const params: HttpParams = this.apiService.queryParams(
      getBillToAccountsParams
    );
    return this.apiService.get(`/v2/bill-to-accounts`, params);
  }

  updateBrandBillingConfig(
    setBrandBillingConfigParams: SetBrandBillingConfigParams
  ): Observable<SetBrandBillingConfigResponse> {
    return this.apiService.put(
      `/v2/brands/${setBrandBillingConfigParams.brandId}/billing-config`,
      setBrandBillingConfigParams
    );
  }
}
